import Blog_50_7_container from "./container/Blog_50_7_container";
export default Blog_50_7_container;
